import { buildURL } from "./buildURL.js";
const buildPixelDensitySrcSet = (url, { pixelDensities, ...params }) => {
  return pixelDensities.map((dpr) => {
    return `${buildURL(url, { ...params, dpr })} ${dpr}x`;
  }).join(", ");
};
export {
  buildPixelDensitySrcSet
};
//# sourceMappingURL=buildPixelDensitySrcSet.js.map
